var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticClass: "home-form-container elevation-2",
      style: { height: _vm.height },
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        active: true,
        parent: true,
        resizable: true,
        "max-height": 700,
        "max-width": 1000,
        "min-width": 656,
        "class-name-handle": "object-form-resizable-handle",
        "drag-handle": ".drag",
        "data-app": ""
      },
      on: { resizing: _vm.onResizing }
    },
    [
      _c(
        "div",
        { ref: "objectForm" },
        [
          _c(
            "form-header",
            {
              attrs: { title: _vm.pageTitle },
              on: { close: _vm.tryCloseForm }
            },
            [
              _vm.userHasFibercloudPermission("workorder", "edit")
                ? _c("form-options-menu", {
                    attrs: {
                      "action-type": _vm.action,
                      "workorder-form": true
                    },
                    on: {
                      clearData: function($event) {
                        return _vm.$emit("clearData")
                      },
                      changeViewModeOfObject: _vm.changeViewModeOfObject,
                      refresh: _vm.refresh
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs",
            {
              attrs: { "background-color": "transparent", color: "accent" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(_vm.tabs, function(item) {
              return _c(
                "v-tab",
                {
                  key: item.tab,
                  staticStyle: {
                    "text-transform": "none",
                    "font-size": "12px"
                  },
                  attrs: { disabled: item.disabled }
                },
                [_vm._v("\n        " + _vm._s(item.tab) + "\n      ")]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(_vm.tabs, function(item) {
              return _c(
                "v-tab-item",
                { key: item.tab },
                [
                  !_vm.loading
                    ? _c(item.content, {
                        tag: "component",
                        attrs: {
                          receivedData: _vm.receivedData,
                          disabledView: _vm.disabledView,
                          actionType: _vm.action,
                          startDate: _vm.receivedData.start_date
                        },
                        on: { objectTemplates: _vm.objectTemplates }
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "d-flex align-center justify-center",
                          staticStyle: {
                            "background-color": "#F0F0EF",
                            height: "535px",
                            overflow: "auto"
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 100,
                              width: 5,
                              color: "accent",
                              indeterminate: ""
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "d-flex justify-space-between mr-3 mb-3" },
        [
          _c(
            "v-btn",
            {
              staticClass: "footer-button ml-6",
              attrs: {
                color: "accent",
                loading: _vm.exportLoading,
                disabled: _vm.hasExportPermissions
              },
              on: { click: _vm.getWorkOrderToExport }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("Export")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  staticClass: "footer-button mr-2",
                  attrs: {
                    text: "",
                    disabled: _vm.tab === 0,
                    color: "var(&#45;&#45;secondary-darker)"
                  },
                  on: { click: _vm.previousButton }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Previous")) + "\n      ")]
              ),
              _vm._v(" "),
              _vm.tab !== 3
                ? _c(
                    "v-btn",
                    {
                      staticClass: "footer-button mr-3",
                      attrs: { color: "accent", disabled: _vm.nextButton },
                      on: { click: _vm.nextButtonJumpToSummary }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("Next")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tab === 3
                ? _c(
                    "v-btn",
                    {
                      staticClass: "footer-button mr-3",
                      attrs: { color: "accent", disabled: _vm.disabledView },
                      on: { click: _vm.saveWorkOrder }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("Save")) + "\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48e32df3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e32df3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderForm.vue
// module id = null
// module chunks = 